import { createFileRoute } from "@tanstack/react-router"
import { CampaignInsights } from "modules/campaigns/components/Detail/Insights"
import z from "zod"

export const Route = createFileRoute("/_base/_auth/campaigns/$id/insights")({
  component: Component,
  validateSearch: z.object({
    openPlayground: z.boolean().optional(),
  }),
})

function Component() {
  const { id } = Route.useParams()

  return <CampaignInsights id={id} />
}
